<template>
	<transition name="menu"> 
		<div class="menu-container" :class="menuOpen" v-if="hasMenu" >
			<div class="menu">
				<div v-if="hasMenu && isLoggedIn"  class="nav-toggle" @click="toggleMenu()">
						<span class="stripe1"></span>
						<span class="stripe2"></span>
						<span class="stripe3"></span>
				</div>
				<router-link :to="{name: 'dashboard'}">
						<img src="~@/assets/logo.svg" :title="version" alt="logo" />
				</router-link>
				<div class="profile" v-if="isLoggedIn">
                    <notifications />
					<shift_notifications  v-if="$isAllowed('isElevated')"/>
					<router-link class="profile_link" :to="{name: 'user'}"><profile-image :disabled="true" /></router-link>
				</div>
			</div>
			<div class="sidemenu" v-if="hasMenu">
				<ul>
					<router-link tag="li" v-if="$isAllowed('accessCalendar')" :to="{name: 'dashboard'}"><i class="material-icons">view_agenda</i></router-link>
					<router-link tag="li" v-if="$isAllowed('accessUsers')" :to="{name: 'users'}"><i class="material-icons">assignment_ind</i></router-link>
                    <router-link tag="li" v-if="$isAllowed('accessPremium')"  :to="{name: 'premium'}"><i class="material-icons">bar_chart</i></router-link>
                    <!-- <router-link tag="li" v-if="$isAllowed('accessUsers')"  :to="{name: 'premium'}"><i class="material-icons">bar_chart</i></router-link> -->
					<router-link tag="li" v-if="$isAllowed('accessCompanies')" :to="companyLink"><i class="material-icons">business</i></router-link>
					<router-link tag="li" :to="{name: 'user'}"><i class="material-icons">person</i></router-link>
					<li @click="logOut"><i class="material-icons">exit_to_app</i></li>
				</ul>
			</div>
		</div>
	</transition>
</template>

<script>
import profileImage from '@/components/profile-image.vue';
import notifications from '@/components/notifications.vue';
import shift_notifications from '@/components/shift_notifications.vue';
import basePerimeter from '@/permissions/basePerimeter.js';
export default {
	data() {
		return {
			open: false
		};
	},
	computed: {

		version() {
			return this.$parent.version;
		},

		hasMenu() {
			return this.$store.state.showMenu;
		},
		showProfile() {
			return this.$store.state.showProfile;
		},
		isLoggedIn(){
			return this.$store.state.user.authenticated;
		},
		menuOpen() {
			return this.open ? "menu-container--open" : "";
		},
		companyLink(){
			// Elevated?
			if ( this.$isAllowed('isElevated') ) {
			  return {name: 'companies'};
			}
			// IF USER HAS JUST 1 COMPANY, REDIRECT TO COMPANY/:ID
			else if(this.$store.state.user.data && this.$store.state.user.data.companies.length > 0){
				return {name: 'companyDetail', 
					params: {
						id: this.$store.state.user.data.companies[0].id
					}
				}
			}

			return {name: 'companies'};
		}
	},
	methods: {
		toggleMenu() {
			this.open = !this.open;
		},
		logOut() {
			this.open = false;
			// Wait for menu to be closed (transition)
			setTimeout(() => {
				this.$store.dispatch("user/logout");
				this.$router.push({ name: "login" });
			}, 100)

		}
	},
	components: {
        profileImage,
        notifications,
		shift_notifications
	},
	perimeters: [
		basePerimeter
	],
	watch: {
		$route(to, from) {
			this.open = false;
		}
	}
};
</script>
<style lang="scss">
@import "~styles/_vars.scss";

.router-link-active {
	 // 
	 img {
	 
		@media (max-width:749px){
			padding-right:150px;
		}
	}
}

.menu {
	position: fixed;
	top: 0px;
	left: 0px;
	background-color: #fff;
	height: 75px;
	width: 100vw;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	z-index: 999;

	.nav-toggle {
		float: right;
		width: $menu-width;
		height: 75px;
		position: fixed;
		z-index: 20;
		top: 0;
		left: 0;
		cursor: pointer;
		padding: 29px 12px;

		span {
			height: 3px;
			width: 25px;
			margin-bottom: 4px;
			display: block;
			background-color: $primary-color;
			transition: all 0.2s;
		}
	}
	.profile {
		position: absolute;
		right: 25px;
		top: 4px;
		img {
			border-radius: 50%;
			height: 50px;
		}	
		a{
			text-decoration: none;
		}
	}
}

.sidemenu {
	position: fixed;
	top: 75px;
	left: -$menu-width;
	height: 100vh;
	z-index: 998;
	transition: left 0.1s ease-in;

	ul {
		background-color: $primary-color;
		margin: 0px;
		height: 100vh;
		width: $menu-width;
		border: none;
		color: white;
		box-shadow: 0px 0px 100px 5px rgba(0, 0, 0, 0.2);
		border-radius: 0px;

		li {
			display: inline-flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 60px;

			&.router-link-exact-active,
			&:hover {
				cursor: pointer;
				img {
					opacity: 1;
				}
			}
			img {
				opacity: 0.47;
			}
		}
	}
}

.menu-container {
	&--open {
		.nav-toggle span {
			&:nth-child(1) {
				transform: rotate(45deg) translateY(5px) translateX(5px);
			}
			&:nth-child(2) {
				display: none;
			}
			&:nth-child(3) {
				transform: rotate(-45deg);
			}
		}

		.sidemenu {
			left: 0px;
		}
	}
	&--big {
		&:not(.menu-container--open) {
			.sidemenu {
				left: -200px;
			}
		}
		.sidemenu {
			ul {
				width: 200px;

				li {
					display: inline-flex;
					justify-content: flex-start;
					align-items: center;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue